export default __webpack_public_path__ + "static/media/bg-100.88c6e041.jpg";